<template>
  <el-drawer
    v-if="showPanel"
    :visible.sync="showPanel"
    direction="rtl"
    :before-close="closePanel"
    :with-header="false"
    custom-class="drawer-panel"
    :size="!expand ? 30 + '%' : 70 + '%'"
  >
    <el-row :gutter="20">
      <el-col :span="expand ? 8 : 24" :offset="0"  :class="{ 'right-divider': expand }">
        <section class="drawer-panel-section text-center">
          <div class="cursor-pointer" @click="showDevData = !showDevData">
            <h3>{{ user.firstName }} {{ user.lastName }}</h3>
            <p class="email">
              {{ user.email }}
            </p>
          </div>

          <transition name="el-zoom-in-top">
            <p v-if="showDevData">
              <sup class="margin-right-unit">
                uid:
                <strong>{{ user.id }}</strong>
              </sup>
              <sup v-if="isRecruiter">
                pid:
                <strong>{{ user.profile.id }}</strong>
              </sup>
            </p>
          </transition>
        </section>

        <el-collapse v-model="collapseItems">
          <Demographics :user="user" />

          <template v-if="isRecruiter">
            <RecruiterProgress :recruiter-progress="user.recruiterProgress" />

            <CompanyInfo :profile="user.profile" />

            <RecruiterActions
              :user="user"
              @expand="toggleExpand"
              :expand="expand"
            />
          </template>

          <template v-else>
            <CandidateActions :user="user"/>
          </template>
        </el-collapse>
      </el-col>
      <el-col :span="expand ? 16 : 0" :offset="0">
        <CampaignsOverview :campaigns="campaigns" class="height-limit"/>
        <ActivityLog :activity="activity" class="height-limit"/>
      </el-col>
    </el-row>
  </el-drawer>
</template>

<script>
import { GlobalEmitter } from '@/utils/GlobalEmitter'
export default {
  name: "UserDrawer",
  components: {
    Demographics: () => import("@/components/UserDrawer/Sections/Demographics"),
    RecruiterProgress: () =>
      import("@/components/UserDrawer/Sections/RecruiterProgress"),
    CompanyInfo: () => import("@/components/UserDrawer/Sections/CompanyInfo"),
    RecruiterActions: () =>
      import("@/components/UserDrawer/Sections/RecruiterActions"),
    CandidateActions: () =>
      import("@/components/UserDrawer/Sections/CandidateActions"),
    CampaignsOverview: () =>
      import("@/components/UserDrawer/Sections/CampaignsOverview"),
      ActivityLog: () =>
      import("@/components/UserDrawer/Sections/ActivityLog"),
  },
  props: {
    showPanel: Boolean,
    user: {
      type: Object,
      required: true,
    },
    isRecruiter: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showDevData: false,
      collapseItems: this.isRecruiter
        ? ["company_info", "actions"]
        : ["demographics", "actions"],
      expand: false,
      pagination: {
        currentPage: 1,
        size: 12,
      },
      campaigns: [],
      activity: [
        
      ]
    };
  },
  methods: {
    toggleExpand() {
      this.expand = !this.expand;
      if (this.expand) {
        this.getProfilePosition();
        this.getActivityLogs();
      }
    },
    getProfilePosition() {
      const params = {
        page: this.pagination.currentPage - 1,
        size: this.pagination.pageSize,
        profileId: this.user.profile.id,
      };

      this.$store
        .dispatch("getProfilePositionsDetailed", { params })
        .then((res) => {
          this.campaigns = res
        });
    },
    getActivityLogs() {
      const params = {
        profileId: this.user.id,
      };

      this.$store
        .dispatch("getUserActivityLog", { params })
        .then((res) => {
          this.activity = res
        });
    },
    closePanel() {
      this.expand = false;
      this.$emit("close");
    },
  },
  created() {
    GlobalEmitter.$on('closePanel', async(dt) => {
      this.closePanel()
    })
  }
};
</script>

<style lang="scss" scoped>
@import "~vars";

.right-divider {
  border-right: 2px solid rgba(69, 75, 96, 0.2); 
}
.height-limit{
  height: 100%;
  max-height: 45vh;
  overflow: auto;
}
.email {
  font-size: $-font-size-m;
  font-style: italic;
}
</style>
